import * as React from 'react';
import _ from 'lodash';
import { Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import { Campaign } from 'types/ts/campaigns.ts';
import { nodeTypeChildOptions } from 'data/trident-campaigns';
import { nodeTypes } from 'data/trident-types';

export const preOrderTraversalFromCurrentNodeToItsChildren = function(
  model: Campaign,
  currentNodeKey: string,
  flowCompleted: boolean,
) {
  const currNode = model.nodes[currentNodeKey];
  const childArray = currNode.children || [];
  if (childArray.length <= 0 && currNode.type !== 'actions') {
    return false;
  }
  childArray.forEach(child => {
    flowCompleted =
      flowCompleted &&
      preOrderTraversalFromCurrentNodeToItsChildren(
        model,
        child,
        flowCompleted,
      );
  });
  return flowCompleted;
};

export const renderDropdownItem = (content: string, onClick: Function) => {
  return (
    <Dropdown.Item onClick={onClick} key={content}>
      {content}
      {
        <Popup
          trigger={<Icon name="info circle" />}
          content={content}
          size="mini"
        />
      }
    </Dropdown.Item>
  );
};

export const getActionsList = (props) => {
  const { model, parentKeyList, currentNode, listRuleTypes } = props;
  const targetUserType = _.get(model, 'targetUserType');
  const isEmptyAction = _.isEmpty(_.get(model, `nodes.${currentNode}.data`, []));
  const treatmentStartNode = _.get(model, `nodes.${parentKeyList[0]}`);

  // get involved event types
  const eventTypes = (treatmentStartNode.type === nodeTypes.time || treatmentStartNode.type === nodeTypes.schedule) ?
    ['onDateAndTime'] : _.map(_.get(treatmentStartNode, 'data.scenarios'), scenario => (scenario.eventType));

  const isAfterCountCondition = () => {
    let i;
    for (i = parentKeyList.length - 1; i > 0; i -= 1) {
      if (_.get(model, `nodes.${parentKeyList[i]}.type`) === nodeTypes.countCondition) {
        return true;
      }
    }
    return false;
  };

  if (isAfterCountCondition()) {
    eventTypes.push('onProfileUpdate');
  }

  let actionTypeOptions = [];
  // each event type has a list of allowed actions
  // we will take the intersection of all the lists to ensure that user can only select actions that are applicable to all the involved event types
  eventTypes.forEach(eventType => {
    const eventTypeData = _.find(_.get(listRuleTypes, targetUserType, []), { eventType });
    if (eventTypeData) {
      const allowedActions = _.filter(
        _.get(eventTypeData, 'allowedActions', []),
        a => { return a.group !== 'user stats'; } // filter out hidden actions
      );

      if (_.isEmpty(actionTypeOptions)) {
        actionTypeOptions = allowedActions;
      } else {
        actionTypeOptions = _.intersectionWith(actionTypeOptions, allowedActions, _.isEqual);
      }
    }
  });

  // TODO: remove once time node is deprecated
  if (treatmentStartNode.type === nodeTypes.time && isEmptyAction) {
    actionTypeOptions = [{ type: 'actionOnGroup', noun: 'Action On Group', group: '', description: 'action on group: pax, dax, max' }];
  }
  return actionTypeOptions;
};

export const isValidJSON = (value: string): boolean => {
  try {
    const parsed = JSON.parse(value);
    return typeof parsed === 'object' && parsed !== null;
  } catch (e) {
    return false;
  }
};

const countTargets = {
  occurrence: 'Occurrence',
  txAmount: 'Transaction Amount',
};

// getCountConditionVarName returns the display name for a given count target
export const getCountConditionVarName = (target: string, scenarios: object[]) => {
  const [targetType, scenarioNo] = target.split('-');
  let scenarioName = _.get(scenarios, `${Number(scenarioNo) - 1}.name`);
  if (_.isEmpty(scenarioName)) {
    scenarioName = `Scenario ${scenarioNo}`;
  }
  return `${scenarioName} ${countTargets[targetType]}`;
};

export const getNodeTypeChildOptions = (userType: string, nodeType: string) => {
  if (window.Grab.config.CHILD_NODES_MAPPING) {
    const childNodes = _.get(window.Grab.config.CHILD_NODES_MAPPING, `${userType}.${nodeType}`, [])
    if (!_.isEmpty(childNodes)){
      return childNodes;
    }
  }

  return _.get(nodeTypeChildOptions, `${userType}.${nodeType}`, []);
};

export const NODE_TYPE_ADD_CONTENT = {
  "condition": "Add Condition",
  "countCondition": "Add Count Condition",
  "actions": "Add Action",
  "count": "Add Counter",
  "delay": "Add Delay",
};
